// extracted by mini-css-extract-plugin
export default {"SuggestError":"qmbIb"};